import type { SitStatTemplate } from './sitstat-template-types';
import { SITSTAT_DEFAULT_LAYOUT } from './sitstat-widget-types';

function cloneLayout(layout: typeof SITSTAT_DEFAULT_LAYOUT) {
  return {
    left: [...layout.left],
    center: [] as typeof layout.center,
    right: [...layout.right],
  };
}

/** Seeded template the AOR card's View SitStat opens, scoped to that AOR. */
export const SITSTAT_AOR_VIEW_TEMPLATE_ID = 'system:aor-view';

export const SITSTAT_SYSTEM_TEMPLATES: SitStatTemplate[] = [
  {
    id: 'system:default-ops',
    slug: 'default-ops',
    name: 'Default Ops',
    layout: cloneLayout(SITSTAT_DEFAULT_LAYOUT),
    uiState: { leftCollapsed: false, rightCollapsed: false },
    isSystem: true,
  },
  {
    id: 'system:compact',
    slug: 'compact',
    name: 'Compact',
    layout: {
      left: ['notifications'],
      center: [],
      right: ['map-layers'],
    },
    uiState: { leftCollapsed: false, rightCollapsed: false },
    isSystem: true,
  },
  {
    id: 'system:ops-focus',
    slug: 'ops-focus',
    name: 'Ops Focus',
    layout: {
      left: ['events', 'incidents'],
      center: [],
      right: ['aors', 'map-layers', 'actions'],
    },
    uiState: { leftCollapsed: false, rightCollapsed: false },
    isSystem: true,
  },
  {
    id: SITSTAT_AOR_VIEW_TEMPLATE_ID,
    slug: 'aor-view',
    name: 'AOR View',
    layout: {
      left: ['notifications', 'events', 'incidents'],
      center: [],
      right: ['aors', 'map-layers', 'actions', 'assets'],
    },
    uiState: { leftCollapsed: false, rightCollapsed: false },
    isSystem: true,
  },
];
